@if(loader){
<app-loader></app-loader>
}

<p-card>
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                        (onClick)="create()" pTooltip="Create Manufacturing Job"></p-button>
    
                </div>
                <!-- <div class="fixed-search-container flex align-items-center justify-content-center flex-grow-1">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" [(ngModel)]="searchKey" placeholder="Search.." class=" p-inputtext-sm"
                                    (keyup.enter)="searchManufacturingProjectBom()" />
                                <p-button icon="pi pi-search" (onClick)="searchManufacturingProjectBom()"
                                    [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}" [raised]="true"
                                    [size]="'small'" severity="info"></p-button>
                            </span>
                        </div> -->
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                            (keyup.enter)="searchManufacturingProjectBom()"
                            style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchManufacturingProjectBom()" [ngStyle]="{ height: '35px' }"
                        [raised]="true" class="ml-2" [size]="'small'" severity="info"></p-button>
                </div>
                <p-button *ngIf="selectedProduct && selectedProduct.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-pencil" size="small" severity="secondary" (onClick)="updateMO()"></p-button>
                <p-button *ngIf="selectedProduct && selectedProduct.length > 0" label="Delete" class="ml-2"
                    icon="pi pi-trash" size="small" severity="danger" (onClick)="deletePMO()"></p-button>
            </div>
    
            <h2 class="page-title-center">Manufacturing Job List</h2>
    
            <div class="flex">
                <div class="flex align-items-center">
                    <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>&nbsp;
            </div>
        </div>


        <p-table #dt1 [value]="manufacturingOrders" [scrollable]="true" scrollHeight="613px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
            [paginator]="true" [rows]="10" [selectionPageOnly]="true" (onPage)="loadProducts($event)"
            [(selection)]="selectedProduct"
            [globalFilterFields]="['batchNumber','startDate','fgQuantity','quantity']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10 ,15, 20]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Job Number</th>
                    <th>Start Date</th>
                    <th *ngIf="!hide">Project Code</th>
                    <th>Finished Goods</th>
                    <th>Quantity To Produce</th>
                    <th pSortableColumn="status">Job Status <p-sortIcon field="status"></p-sortIcon></th>
                    <th>Finished Qty</th>
                    <!-- <th>Waste Qty</th> -->
                    <th>Finished Date</th>
                    <th>{{unitLabel}} Name</th> 
                    <th>Created By</th>
                    <th>Print</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-manufacturingorder>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="manufacturingorder"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="updateMO(manufacturingorder)">
                      {{manufacturingorder.batchNumber}}</td>
                     @if(isDate){
                      <td>{{manufacturingorder.startDate}}</td>

                      }@else {
                      <td>{{manufacturingorder.startDate}}</td>
                      }
                    <td *ngIf="!hide">{{manufacturingorder.projectBOMCode}}</td>
                    <td>{{manufacturingorder.fgProductCode}}</td>
                    <td>{{manufacturingorder.fgQuantity}}</td>
                    <td [ngStyle]="{
                      'color': manufacturingorder.status === 'Batch Created' ? '#fa8202' :
                               manufacturingorder.status === 'Batch Finished' ? '#0fdf00' :
                               'blue'
                    }">{{manufacturingorder.status}}</td>
                    <td>{{manufacturingorder.quantity}}</td>
                    <!-- <td>{{manufacturingorder.wasteQuantity}}</td> -->
                    <td>{{manufacturingorder.endDate | date: 'dd/MM/yyyy'}}</td>
                    <td>{{manufacturingorder.warehouseCode}}</td>
                    <td>{{manufacturingorder.createdBy}}</td>
                    <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                            (click)="showReports(manufacturingorder)"></span></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
